// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3TBO_","savePackageButton":"ClientWallet_savePackageButton__2TUuI"};